import React, {
    useContext
} from 'react';
import {
    Dialog, DialogContent,
} from 'shared/components/ui/dialog';
import {
    Context
} from 'shared/context/GlobalState';
import {
    channelService
} from 'shared/api';
import VoiceSetup from './VoiceSetup';
import type {
    Channel
} from '../../types/builderChannel.types';
import type {
    VoiceChannelData
} from './VoiceSetup';

interface VoiceUpdateProps {
    isOpen: boolean;
    setOpenVoiceModal: (open: boolean) => void;
    channel: Channel;
    setEmailChannels: React.Dispatch<React.SetStateAction<Channel[]>>;
}

export default function VoiceUpdate({
    isOpen, setOpenVoiceModal, channel, setEmailChannels
}: VoiceUpdateProps) {

    const {
        addNewNotifcation
    } = useContext(Context);

    const handleOnSubmit = async (channelObj: VoiceChannelData) => {
        // Server update schema is strict: only the keying fields + topic are sent.
        const channelObj1 = {
            org_id: channel.org_id,
            sub_org_id: channel.sub_org_id,
            channelId: channel._id,
            topic: channelObj.topic,
        };

        try {
            await channelService.updateChannel(channelObj1);

            setEmailChannels((prev) =>
                prev.map((item) => (item._id === channelObj._id ? {
                    ...item,
                    ...channelObj
                } as Channel : item))
            );
            addNewNotifcation('Channel Updated successfully', 'success');
            setOpenVoiceModal(false);
        } catch (error: any) {
            if (error.response?.status === 404) {
                addNewNotifcation('Channel not found', 'danger');
            } else {
                addNewNotifcation('Something went wrong', 'danger');
            }
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={setOpenVoiceModal}>
            <DialogContent className="p-0 sm:max-w-[860px] max-w-none overflow-y-auto max-h-[95svh] sm:max-h-[90vh]">
                <VoiceSetup
                    isUpdate={true}
                    newChannelObj={channel}
                    onSubmit={handleOnSubmit}
                    setOpenEmailModal={setOpenVoiceModal}
                />
            </DialogContent>
        </Dialog>
    );
}
